/**
 * 下挂菜商卡类型声明
 */
import { JumpTypeEnum } from "./jumpPage";
import { PRODUCT_CATEGORY_TYPE } from "./productCard";

export interface Poi {
  title: string;
  headImage: string;
  avgDeliveryTime: number;
  score: string;
  tagInfoList: PoiTagInfo[];
  poiPrice: PoiPrice;
  monthSaleNum: string;
  distance: string;
  operation: Operation;
  coupon: PoiCoupon;
  skuList: Sku[];
  poiIdStr: string;
}

// 品类标签
export enum CategoryType {
  WAIMAI = 7, // 外卖
}

// Poi 标签
export enum PoiTagType {
  RANK = 1, // 排名
  DIANPING = 2, // 点评
  MAGIC_COUPON = 3, // 神券
  CUT = 4, // 满减
  SHIP = 6, // 配送
  WAIMAI_CATEGORY = 7, // 外卖品类标签
}

export interface PoiTagInfo {
  text: string;
  type: PoiTagType;
  icon: string | null;
}

// Poi 价格
export interface PoiPrice {
  avgPrice: string | null;
  minPrice: string;
  shippingFee: string;
}

// 商卡点击跳转配置
export interface Operation {
  jumpLink: string;
  jumpLinkType: JumpTypeEnum;
  appId: string;
  // redirect: number;
}

export interface PoiCoupon {
  wayneId: string;
  title: string;
  value: number; // 券面额
  timeDesc: number;
  minMoney: number; // 券门槛
  minMoneyDesc: string;
  voucherTypeDesc: string;
  toUseUrl: null;
  segmentIdList: null;
  couponConfigId: string;
  couponViewId: string;
}

export enum CouponSource {
  RECALL, // 券平台召回的最优下挂券，由接口下发
  COUPON_SELECTION, // 券快筛
}

export interface EnhancedPoiCoupon {
  actSysSrc: string;
  couponValue: string;
  priceLimit: string;
  couponConfigId: string;
  couponViewId: string;
  couponEndTime: number;
  couponSource: CouponSource;
}

// 下挂菜商卡的 sku
export interface Sku {
  title: string;
  productId: string;
  headImage: string;
  finalPrice: string;
  originPrice: string | null;
  savingAmount: string | null;
  operation: Operation;
}

// 前端处理后的 POI 数据
export interface EnhancedPoi {
  title: string;
  headImage: string;
  score?: number | string;
  monthSaleNum?: string;
  minPrice?: string;
  shippingFee?: string;
  avgDeliveryTime?: number | string;
  distance?: string;
  finalPrice?: string;
  skuId?: string;
  poiIdStr: string;
  rankLabel: string;
  dianpingLabel: string;
  magicCouponLabel: string;
  categoryLabel?: {
    type: CategoryType | null;
    label: string;
  };
  cutLabels: string[];
  shipIcon: string;
  operation: Operation;
  skuList?: Sku[];
  categoryType?: PRODUCT_CATEGORY_TYPE;
  coupon?: EnhancedPoiCoupon | null;
}
